import React from "react";

export default function Loading({ label = "Loading…" }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center" role="status" aria-live="polite" aria-label={label}>
      <div className="absolute inset-0 bg-black/20" />
      <div className="relative z-10 w-40 h-40 rounded-xl shadow border border-line bg-surface flex flex-col items-center justify-center gap-3">
        <div className="w-8 h-8 rounded-full border-2 border-line border-t-neutral-700 animate-spin" />
        <span className="text-sm text-ink">{label}</span>
      </div>
    </div>
  );
}
